import NewPageContainer from '../components/page-container/NewPageContainer';
import FirmDashboard from '../features/firm-dashboard/FirmDashboard';

function FirmDashboardPage(): JSX.Element {
    return (
        <NewPageContainer>
            <FirmDashboard />
        </NewPageContainer>
    );
}

export default FirmDashboardPage;
